export enum ETestLabels {
  PING      = 'ping',
  DOWNLOAD  = 'download',
  UPLOAD    = 'upload',
}
